var SpeedUnit;
(function (SpeedUnit) {
    SpeedUnit["FRAME"] = "f";
    SpeedUnit["SECOND"] = "s";
})(SpeedUnit || (SpeedUnit = {}));
export { SpeedUnit };
